/**
 * Button-group-item adapter for CodeStitch `.cs-button-group` clusters.
 *
 * Recognises the direct anchor children of a `.cs-button-group` (e.g.
 * `a.cs-button-solid`, `a.cs-button-transparent`). Button anchors carry varying
 * classes, so the repeat root is expressed positionally as `.cs-button-group > a`
 * rather than by a single button class.
 *
 * `reorderAxis:'flow'`: a hero/CTA button group is a horizontal `flex-wrap`
 * row, but a FAQ filter `.cs-button-group` can be column-then-row — the axis is
 * resolved from the live parent layout at drag start.
 */

import { moveSiblingPreservingEids } from '../element-insert.js';

export const buttonGroupItemAdapter = {
  kind: 'button-group-item',
  label: 'Button',
  itemSelector: '.cs-button-group > a',
  parentSelector: '.cs-button-group',
  reorderSelector: '.cs-button-group > a',
  reorderSiblingSelector: '.cs-button-group > a',
  reorderAxis: 'flow',
  historyLabel: 'Reorder button',
  toastText: 'Button reordered',
  vtPrefix: 'pb-btn-',
  vtSelector: '.cs-button-group > a',
  moveFn: moveSiblingPreservingEids,
  menuActions: ['duplicate', 'delete'],
  postInsertFlow: null,
  cssPatch: null,
  reorderable: true,

  match(probe) {
    if (!probe || typeof probe.closest !== 'function') return null;
    if (!probe.closest('.cs-button-group')) return null;
    return probe.closest('a');
  }
};
